import get from 'lodash/get';
import { getRequiredMatchingByType } from '../pages/importManager/managedStructure';

export function nextStepValidate(current, importData, setHideRequiredFields) {
  let canNext;

  switch (current) {
    case 0: {
      canNext = importData.settings.type;
      break;
    }
    case 1: {
      canNext = importData.settings.source;
      break;
    }
    case 2: {
      canNext = importData.preprocess;
      break;
    }
    case 3: {
      if (importData.settings.userContactId) {
        canNext =
          importData.matchedProperties.some((property) => property.getProspect === 'getProspectId') &&
          importData.matchedProperties.some(
            (property) => !['dontImport', 'getProspectId'].includes(property.getProspect),
          );

        if (canNext) {
          canNext =
            get(importData, 'preprocess.headers.length', 0) === importData.matchedProperties.length ||
            (importData.matchedProperties.length !== 0 && importData.settings.unmatchedImport);
        }

        break;
      }

      const requiredProperties = getRequiredMatchingByType(importData?.settings?.type, importData?.settings?.source);

      if (requiredProperties) {
        let passedValidate = requiredProperties.primary.some((group) =>
          group.every((item) => importData.matchedProperties.some((propItem) => propItem.getProspect === item)),
        );

        if (passedValidate && requiredProperties.additional.length) {
          passedValidate = requiredProperties.additional.some((group) =>
            group.every((item) => importData.matchedProperties.some((propItem) => propItem.getProspect === item)),
          );
        }
        canNext = passedValidate;
        setHideRequiredFields(canNext);

        if (canNext) {
          canNext =
            (get(importData, 'preprocess.headers.length', 0) === importData.matchedProperties.length ||
              (importData.matchedProperties.length !== 0 && importData.settings.unmatchedImport)) &&
            importData.matchedProperties.length !== 0;
        }
      }

      break;
    }
    case 4: {
      canNext = importData.settings.name.length;
      if (get(importData, 'settings.createList') && !get(importData, 'settings.lists')) {
        canNext = false;
      }
      break;
    }
    default:
      canNext = false;
  }

  return canNext;
}

export const getNumberRows = async (file) => {
  const numberRows = await new Promise((res, rej) => {
    let _numberRows = 0;
    const fileReader = new FileReader();
    fileReader.onload = (e) => {
      const content = e.target.result;
      let inQuote = false;
      let currentRow = '';
      for (let i = 0; i < content.length; i += 1) {
        const char = content[i];
        const nextChar = content[i + 1];
        if (char === '"') {
          inQuote = !inQuote;
        }
        if ((char === '\n' || (char === '\r' && nextChar === '\n')) && !inQuote) {
          if (currentRow.trim().replace(/["',\s]/g, '').length > 0) {
            _numberRows += 1;
          }
          currentRow = '';
          if (char === '\r') i += 1;
        } else {
          currentRow += char;
        }
      }
      if (currentRow.trim().replace(/["',\s]/g, '').length > 0) {
        _numberRows += 1;
      }
      res(_numberRows);
    };
    fileReader.onerror = (err) => {
      rej(err);
    };
    fileReader.readAsText(file);
  });
  return numberRows;
};
